import { Field } from 'formik';
import formikMetaToState from '../../helpers/formikMetaToState';
import { RadioButton, RadioButtonProps } from '../RadioButton';

// Formik 2.x supports only string values in radio buttons, it will be fixed in ver. 3
// Apply custom fix. Parse value and convert it to boolean if possible
export const FormikRadioButton = (props: RadioButtonProps & { name: string }) => {
  const { name, ...newProps } = props;
  const isBoolean = (str?: string) => str && (str.toLowerCase() === 'true' || str.toLowerCase() === 'false');
  const strToBoolean = (str?: string) => str && str.toLowerCase() === 'true';
  return (
    <Field name={name}>
      {({ field, meta, form }: any) => {
        const { error } = formikMetaToState(meta);
        return (
          <RadioButton
            {...field}
            {...newProps}
            error={error}
            onChange={(e) => {
              const value = e.currentTarget.value;
              form.setFieldValue(field.name, isBoolean(value) ? strToBoolean(value) : value);
            }}
          />
        );
      }}
    </Field>
  );
};
